import { _ as __vue_normalize__ } from './normalize-component.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    beacons: {
      required: true
    }
  },
  data: function data() {
    return {
      number: '',
      validChars: [],
      ready: false
    };
  },
  mounted: function mounted() {
    this.updateValidChars();
  },
  computed: {
    selectedPage: function selectedPage() {
      return this.beacons[this.number];
    },
    pageTitle: function pageTitle() {
      if (this.beacons[this.number]) {
        var title = this.beacons[this.number].title.replace(new RegExp('^' + this.number + ' '), '');
        return title;
      }

      return '';
    }
  },
  methods: {
    updateValidChars: function updateValidChars() {
      var position = this.number.length;
      var validChars = {};

      for (var beacon in this.beacons) {
        if (beacon.length >= position && beacon.substr(0, position) === this.number) {
          validChars[beacon.charAt(position)] = 0;
        }
      }

      this.validChars = Object.keys(validChars);
    },
    onNumClick: function onNumClick(num) {
      var _this = this;

      this.number = this.number + num;
      this.updateValidChars();

      if (Object.keys(this.beacons).includes(this.number)) {
        setTimeout(function () {
          return _this.$refs.enter.focus();
        }, 100);
      }
    },
    onDelClick: function onDelClick() {
      if (this.number.length > 0) {
        this.number = this.number.slice(0, -1);
        this.updateValidChars();
      }
    },
    isNumEnabled: function isNumEnabled(num) {
      return this.validChars.indexOf(num) >= 0;
    },
    onSelectPage: function onSelectPage() {
      if (this.selectedPage) {
        this.$router.push('/page/' + this.selectedPage.pageID);
      }
    }
  },
  watch: {
    beacons: function beacons(val) {
      this.ready = !!val && Object.keys(val).length > 0;
      this.updateValidChars();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-numpad" }, [
    _c(
      "div",
      { staticClass: "c-numpad__display", attrs: { "aria-live": "polite" } },
      [
        _c("span", { staticClass: "c-numpad__number" }, [
          _vm._v(_vm._s(_vm.number))
        ]),
        _c("span", { staticClass: "c-numpad__title" }, [
          _vm._v(_vm._s(_vm.pageTitle))
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-numpad__pad" },
      [
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__1", disabled: !_vm.isNumEnabled("1") },
            on: {
              click: function($event) {
                return _vm.onNumClick("1")
              }
            }
          },
          [_vm._v("1")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__2", disabled: !_vm.isNumEnabled("2") },
            on: {
              click: function($event) {
                return _vm.onNumClick("2")
              }
            }
          },
          [_vm._v("2")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__3", disabled: !_vm.isNumEnabled("3") },
            on: {
              click: function($event) {
                return _vm.onNumClick("3")
              }
            }
          },
          [_vm._v("3")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__4", disabled: !_vm.isNumEnabled("4") },
            on: {
              click: function($event) {
                return _vm.onNumClick("4")
              }
            }
          },
          [_vm._v("4")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__5", disabled: !_vm.isNumEnabled("5") },
            on: {
              click: function($event) {
                return _vm.onNumClick("5")
              }
            }
          },
          [_vm._v("5")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__6", disabled: !_vm.isNumEnabled("6") },
            on: {
              click: function($event) {
                return _vm.onNumClick("6")
              }
            }
          },
          [_vm._v("6")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__7", disabled: !_vm.isNumEnabled("7") },
            on: {
              click: function($event) {
                return _vm.onNumClick("7")
              }
            }
          },
          [_vm._v("7")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__8", disabled: !_vm.isNumEnabled("8") },
            on: {
              click: function($event) {
                return _vm.onNumClick("8")
              }
            }
          },
          [_vm._v("8")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__9", disabled: !_vm.isNumEnabled("9") },
            on: {
              click: function($event) {
                return _vm.onNumClick("9")
              }
            }
          },
          [_vm._v("9")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__0", disabled: !_vm.isNumEnabled("0") },
            on: {
              click: function($event) {
                return _vm.onNumClick("0")
              }
            }
          },
          [_vm._v("0")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: {
              id: "c-numpad__back",
              disabled: this.number.length === 0,
              title: _vm.$t("global.numPadBack"),
              "area-label": "$t('global.numPadBack')"
            },
            on: {
              click: function($event) {
                return _vm.onDelClick()
              }
            }
          },
          [_c("span", { staticClass: "xp xp--large xp-backspace" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "enter",
            staticClass: "c-numpad__button link",
            attrs: {
              id: "c-numpad__enter",
              disabled: !_vm.selectedPage,
              title: _vm.$t("global.numPadEnter"),
              "area-label": "$t('global.numPadEnter')"
            },
            on: { click: _vm.onSelectPage }
          },
          [_c("span", { staticClass: "xp xp--large xp-check" })]
        ),
        _vm._v(" "),
        _vm._l(
          this.$xp.settings.mergedSettings.navigation.numpadInputExtraButtons,
          function(char, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "c-numpad__button link",
                attrs: { disabled: !_vm.isNumEnabled(char) },
                on: {
                  click: function($event) {
                    return _vm.onNumClick(char)
                  }
                }
              },
              [_vm._v(_vm._s(char))]
            )
          }
        )
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
